import React, { useState } from "react";
import managementBanner from '../../Assets/Images/managementSystemBanner.png'
import {   MdKeyboardDoubleArrowDown, MdKeyboardDoubleArrowRight } from "react-icons/md";

const ManagementSystemCert = () => {

    const [openIndex, setOpenIndex] = useState(null);

  const data = [
  {
    title: "ISO 9001 – Quality Management Systems",
    content:
      "ISO 9001 helps you deliver consistent quality, boost customer satisfaction, and improve efficiency for lasting success.",
  },
  {
    title: "ISO 14001 – Environmental Management Systems",
    content:
      "ISO 14001 empowers you to enhance environmental performance, optimize resource use, and demonstrate a solid commitment to sustainability.",
  },
  {
    title: "ISO 45001 – Occupational Health & Safety",
    content:
      "ISO 45001 enables you to protect your workforce, systematically manage health and safety risks, and create a safer working environment.",
  },
  {
    title: "ISO 22000 – Food Safety Management Systems",
    content:
      "ISO 22000 supports you in safeguarding food safety, controlling hazards, and ensuring confidence across the food supply chain.",
  },
  {
    title: "ISO 27001 – Information Security Management",
    content:
      "ISO 27001 helps you protect sensitive information, reduce cyber risks, and build trust with clients through robust information security management.",
  },
  {
    title: "ISO 13485 – Medical Devices Quality Management",
    content:
      "ISO 13485 ensures the quality and safety of medical devices, enabling you to meet international regulatory requirements and boost market trust.",
  },
  {
    title: "ISO 27701 – Privacy Information Management",
    content:
      "ISO 27701 strengthens your privacy management practices, letting you manage and protect personal data in compliance with global data protection regulations.",
  },
  {
    title: "ISO 20000-1 – IT Service Management",
    content:
      "ISO 20000-1 optimizes your IT service management processes, ensuring reliable, high-quality IT services aligned with business objectives.",
  },
  {
    title: "ISO 26000 – Social Responsibility",
    content:
      "ISO 26000 guides your organization to operate ethically, enhance social responsibility, and contribute to sustainable development.",
  },
  {
    title: "ISO 22301 – Business Continuity Management",
    content:
      "ISO 22301 fortifies your business continuity capabilities, preparing you to recover swiftly from disruptions and ensure operational resilience.",
  },
  {
    title: "ISO 42001 – Artificial Intelligence Management Systems",
    content:
      "ISO 42001 establishes robust governance for artificial intelligence systems, driving responsible use and trustworthy AI solutions.",
  },
  {
    title: "ISO 27017 – Cloud Security Controls",
    content:
      "ISO 27017 provides tailored information security controls for cloud services, ensuring secure and compliant cloud environments.",
  },
  {
    title: "ISO 27018 – Protection of Personal Data in Cloud",
    content:
      "ISO 27018 safeguards personally identifiable information in the cloud, reinforcing privacy, and compliance for cloud service providers.",
  },
  {
    title: "ISO 50001 – Energy Management Systems",
    content:
      "ISO 50001 helps you improve energy performance, reduce operating costs, and demonstrate leadership in sustainability.",
  },
  {
    title: "ISO 37001 – Anti-Bribery Management Systems",
    content:
      "ISO 37001 enables you to prevent, detect, and respond to bribery risks, strengthening your culture of integrity and compliance.",
  },
  {
    title: "ISO 41001 – Facility Management Systems",
    content:
      "ISO 41001 streamlines facility management processes, delivering operational efficiency and a superior built environment.",
  },
  {
    title: "ISO 21001 – Educational Organizations Management Systems",
    content:
      " ISO 21001 enhances educational management systems, improving learning quality and satisfaction for all stakeholders.",
  },
  {
    title: "ISO 55001 – Asset Management Systems",
    content:
      "ISO 55001 empowers you to manage assets efficiently, maximize value, and assure sustainable organizational performance.",
  },
  {
    title: "ISO 28000 – Supply Chain Security Management Systems",
    content:
      "ISO 28000 strengthens supply chain security, reducing risks and assuring safety in logistics and supply chain operations.",
  },
  {
    title: "ISO 22716 – Cosmetics Good Manufacturing Practices",
    content:
      "ISO 22716 delivers guidelines for cosmetics GMP, ensuring safe, high-quality products and regulatory compliance.",
  },
];


  const toggleContent = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  return (
    <div className="service container">
      <div className="service-management-system">
        <div className="row service-management-system-header">
          <div className="col-lg-6">
            <h1 className="management-system-heading">
              ISO CERTIFICATION
            </h1>
          </div>
          <div className="col-lg-6">
            <p className="management-system-content">
              Our Management System Certification services help your business
              meet international ISO standards with ease. We guide you through
              every step, ensuring compliance, improving efficiency, and
              enhancing your credibility in the marketplace
            </p>
          </div>
        </div>

        
       <div className="service-management-system-option">
  <div className="row">
    <div className="col-lg-7 management-system-option-content scrollable-list">
  {data.map((item, index) => (
    <div
      key={index}
      className={`service-option ${openIndex === index ? "active" : ""}`}
    >
      <div
        className="service-option-header"
        onClick={() => toggleContent(index)}
      >
        {openIndex === index ? (
          <MdKeyboardDoubleArrowDown size={22} className="arrow-icon" />
        ) : (
          <MdKeyboardDoubleArrowRight size={22} className="arrow-icon" />
        )}
        <h2 className="service-title">{item.title}</h2>
      </div>

      {openIndex === index && (
        <div className="service-management-content">
          <p>{item.content}</p>
        </div>
      )}
    </div>
  ))}
</div>

<div className="col-lg-5 management-system-banner-content">
  <img
    className="management-system-banner"
    src={managementBanner}
    alt="management banner"
  />
</div>

  </div>
</div>



      </div>
    </div>
  );
};

export default ManagementSystemCert;
